var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVideoCall2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45.301,
    height: 25.671,
    viewBox: "0 0 45.301 25.671",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12516",
    d: "M174.562-256.443a1.008 1.008 0 0 0-.562.995 1 1 0 0 0 .609 1.007 1.118 1.118 0 0 0 1.568-1.393 1.461 1.461 0 0 0-.339-.527 1.329 1.329 0 0 0-1.276-.082z",
    transform: "translate(-160.002 273.9)",
    style: {
      fill: "#505050"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12518",
    d: "m41.322-467.293 12.484-6.863v23.437l-12.484-6.4z",
    transform: "translate(-9.716 475.15)",
    style: {
      fill: "#f37b89"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12515",
    d: "M93.6-401.525c-3.148 1.732-5.77 3.16-5.817 3.16s-.094-.3-.094-.679a5.652 5.652 0 0 0-.679-2.435 6.339 6.339 0 0 0-1.943-1.966c-1.276-.749-.445-.7-13.94-.749-8.392-.023-10.61.012-11.125.094a5.517 5.517 0 0 0-4.3 3.769c-.2.573-.211 1.147-.211 8.521s.012 7.947.211 8.521a5.517 5.517 0 0 0 4.3 3.769c.515.082 2.732.117 11.125.094 11.119-.035 12.348-.059 12.84-.234a5.479 5.479 0 0 0 3.722-4.928c0-.562.035-.679.176-.62.094.035 2.739 1.463 5.864 3.184 5.22 2.856 5.723 3.113 6.121 3.043a1.279 1.279 0 0 0 .691-.363l.257-.3v-24.322l-.269-.3a1.037 1.037 0 0 0-.726-.363c-.43-.056-.886.166-6.203 3.104zm-9.949-.035a3.4 3.4 0 0 1 1.455 1.56c.234.515.246.737.246 8.193s-.012 7.678-.246 8.193a3.4 3.4 0 0 1-1.451 1.557l-.468.257H60.065l-.48-.257a3.229 3.229 0 0 1-1.732-2.458l-.07-.492 4.682-.035 4.682-.035.316-.328a.936.936 0 0 0 .328-.784.936.936 0 0 0-.328-.784l-.316-.328-4.693-.035-4.682-.035.035-6.051c.035-5.852.047-6.063.281-6.578a3.36 3.36 0 0 1 2.037-1.767c.164-.047 3.926-.082 10.715-.07l12.348.023zm14.783 14.584-.035 4.834-5.349-2.926-5.361-2.938v-7.608l5.361-2.938 5.349-2.926.035 4.834c.015 2.657.015 7.011.003 9.668z",
    transform: "translate(-55.5 404.644)",
    style: {
      fill: "#6f7e8e"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoCall2);
export default __webpack_public_path__ + "static/media/video-call-_2_.4c3ee9f515b381f4a8fe739b5e0e05eb.svg";
export { ForwardRef as ReactComponent };